import { getQuartzConfig } from 'quartz-config/evaluable';
import { invariant } from 'quartz/invariant';
import registerAllPublicData from 'I18n/init/register/sync/registerAllPublicData';
import { getHstc } from 'usage-tracker-core/common/defaultTrackers';
const quartzConfig = getQuartzConfig();
/* invariant(quartzConfig.auth === 'none') */
;
export const adapter = {
  initialize() {
    return Promise.resolve(adapter.initializeWithState());
  },
  setGlobalState() {},
  getUserId() {
    return undefined;
  },
  initializeWithState() {
    return {
      gates: new Set()
    };
  },
  getI18nConfig() {
    return {
      isPublicI18n: true,
      registerFn: registerAllPublicData
    };
  },
  getTrackingProperties() {
    return {
      email: null,
      hstc: getHstc(),
      hubId: null
    };
  },
  shouldUseLegacyRoot() {
    return !quartzConfig.createRootApi || quartzConfig.createRootApi === 'tests-only';
  }
};